import { book } from '../routers/books';
import { CPGJOBS_SITE_URL } from '../components/CpgChrome/cpgSites';

type SiteId = number | null | undefined;

export interface IOriginJobSite {
  name: string;
  url: string;
}

const ORIGIN_JOB_SITES: Record<number, { name: string; baseUrl: string }> = {
  1: { name: 'BevNET', baseUrl: 'https://www.bevnet.com' },
  2: { name: 'Brewbound', baseUrl: 'https://www.brewbound.com' },
  3: { name: 'Nosh', baseUrl: 'https://www.nosh.com' },
};

const getEncodedJobPath = (
  path: string | null | undefined
): string | null => {
  if (!path) return null;

  const cleanPath = path
    .replace(/^\/+/, '')
    .replace(/^jobs\//, '')
    .replace(/\/+$/, '');
  return cleanPath ? encodeURIComponent(cleanPath) : null;
};

const withPathQuery = (route: string, eguid: string): string => (
  `${route}?path=${encodeURIComponent(eguid)}`
);

export const getEditJobPath = (siteId: SiteId, eguid: string): string => {
  if (siteId === 2) return book.editJobBrewbound(eguid);
  if (siteId === 3) return book.editJobNosh(eguid);
  return book.editJob(eguid);
};

export const getReactivateJobPath = (siteId: SiteId, eguid: string): string => {
  if (siteId === 2) return withPathQuery(book.reactivateListingBrewbound, eguid);
  if (siteId === 3) return withPathQuery(book.reactivateListingNosh, eguid);
  return withPathQuery(book.reactivateListing, eguid);
};

export const getUpgradeJobPath = (siteId: SiteId, eguid: string): string => {
  if (siteId === 2) return book.upgradeJobBrewbound(eguid);
  if (siteId === 3) return book.upgradeJobNosh(eguid);
  return book.upgradeJob(eguid);
};

export const getPostPrepaidJobPath = (siteId: SiteId, guid: string): string => {
  if (siteId === 2) return book.postPrepaidListingBrewbound(guid);
  if (siteId === 3) return book.postPrepaidListingNosh(guid);
  return book.postPrepaidListing(guid);
};

export const getPrepaidPurchasePath = (siteId: SiteId): string => {
  if (siteId === 2) return book.jobsBrewbound;
  if (siteId === 3) return book.jobsNosh;
  return book.jobs;
};

export const getReceiptPath = (siteId: SiteId, eguid: string): string => {
  const query = `?eguid=${encodeURIComponent(eguid)}`;
  if (siteId === 2) return `${book.receiptBrewbound}${query}`;
  if (siteId === 3) return `${book.receiptNosh}${query}`;
  return `${book.receipt}${query}`;
};

export const getPublicJobUrl = (
  _siteId: SiteId,
  path: string | null | undefined
): string | null => {
  const encodedPath = getEncodedJobPath(path);
  return encodedPath ? `${CPGJOBS_SITE_URL}/jobs/${encodedPath}` : null;
};

export const getOriginJobSiteName = (siteId: SiteId): string | null => (
  siteId ? ORIGIN_JOB_SITES[siteId]?.name || null : null
);

export const getOriginJobSite = (
  siteId: SiteId,
  path: string | null | undefined
): IOriginJobSite | null => {
  if (!siteId) return null;

  const site = ORIGIN_JOB_SITES[siteId];
  const encodedPath = getEncodedJobPath(path);
  if (!site || !encodedPath) return null;

  return {
    name: site.name,
    url: `${site.baseUrl}/jobs/${encodedPath}`,
  };
};
